import { Box, Stack, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import ChatSkeleton from "../../components/ChatSkeleton";
import { useGetState } from "../../context/useGetState";
import _ from 'lodash';
import moment from "moment"
import { ChatFeed } from "./ChatFeed";
import MessageBox from "./MessageBox";
import WelcomeChat from "./WelcomeChat";
import { getMessages } from "./service";
import axios from "axios";
import Fancybox from "../dashboard/discover/stories/Fancybox";
import { useParams } from "react-router";
import FancyboxGallery from "./FancyboxGallery"; //not used

function ChatArea({
  socket,
  currentChat,
  handleSendMsg,
  handleSendFile,
  typingUserId,
  accountType,
  privateChatRecipient,
  chatContext,
  messages,
  loading,
  ...props
}) {
  const { state } = useGetState();
  const loggedInUser = state?.userInfo;




  const groupProp1 = _.property('updatedAt');
  const groupProp = _.property('created_at');

  let determineGroup = value => {
    // remove '2017-11-15' to actually use current date 
    const now = moment().startOf('day');
    console.log('now', now)

    if (value.isSame(now, 'day')) {
      return 'today';
    }
    if (value.isAfter(now.clone().subtract(7, 'days').startOf('day'))) {
      return 'this week';
    }
    if (value.isSame(now, 'month')) {
      return 'this month';
    }
    return value.format('DD/MM/YY');
  };

  let groupedData = _
    .chain(messages)
    .groupBy(datum => determineGroup(moment(groupProp(datum))))
    .value();

  function renderObject() {
    return Object.entries(groupedData).map(([key, value], i) => {
      return (
        <div key={key}>                   <Box ml={'50%'} borderRadius="lg">



          <Text
            whiteSpace="pre-wrap"
            p="10px"
            fontSize={["1.4em", ".8em", ".8em", ".8em"]}
            maxW="300px"
            color="#7B8793"
          >
            {key}
          </Text>
        </Box>
          {value.map((val, index) => {
            return (<>          <ChatFeed
              message={val}
              key={index}
              chatContext={chatContext}
              state={state}
              {...props}
            /></>)
          })}


        </div>
      )
    })
  }


  console.log('grouped-->', groupedData);
  const ref = useRef(null);
  const { privateUserId } = useParams();
  const [parentWidth, setParentWidth] = useState(0);
  const [messagesPrivateChatRecipient, setMessagesPrivateChatRecipient] = useState([]);
  //   useEffect(() => {
  //     const chatAreaElement = document.getElementsByClassName("chat-area")[0];

  // setParentWidth(ref?.current?.offsetWidth);
  //       const resize = () => {
  //         setParentWidth(ref?.current?.offsetWidth);
  //       };
  //     if (chatAreaElement) {
  //       const resizeObserver = new ResizeObserver((entries) => {
  //         resize();
  //       });

  //       resizeObserver.observe(document.getElementsByClassName("chat-area")[0]);
  //     }
  //   }, []);
  //     useEffect(() => {}, [parentWidth, ref?.current?.offsetWidth]);
  useEffect(() => {
    const chatAreaElement = document.getElementsByClassName("chat-area")[0];

    setParentWidth(ref?.current?.offsetWidth);

    const resize = () => {
      setParentWidth(ref?.current?.offsetWidth);
      //console.log("ref", ref.current?.offsetWidth);
    };

    const resizeObserver = new ResizeObserver((entries) => {
      resize();
    });
    setTimeout(() => {
      resizeObserver.observe(chatAreaElement);
    }, 100);



  }, []);

  //console.log("parent",props.isOpen, parentWidth);

  return loading &&
    privateChatRecipient === undefined &&
    currentChat === undefined ? (
    // return loading && messages.length < 1 ?  (
    <WelcomeChat className="chat-area" />
  ) : (
    <Stack
      className="chat-area scroll-container"
      position={"relative"}
      p="10px"
      height={[window.innerHeight - 300, window.innerHeight - 100]}
      maxH={["unset", window.innerHeight - 250]}
      overflowY={"scroll"}
      ref={ref}
      spacing="20px"
      bg="transparent !important"
    >
      {renderObject()}


      <Box mt="50px !important" />
      <MessageBox
        handleSendMsg={handleSendMsg}
        handleSendFile={handleSendFile}
        socket={socket}
        currentChat={currentChat}
        typingUserId={typingUserId}
        width={ref?.current?.offsetWidth}
        accountType={accountType}
        privateChatRecipient={privateChatRecipient}
        {...props}
      />
    </Stack>
  );
}

export default ChatArea;
